import { minutesToMilliseconds } from 'date-fns';

export const POLLING_INTERVAL_IN_MILLISECONDS = minutesToMilliseconds(2);
